import {Utils} from '@/common/scripts/utils';

class ParallaxMouse {
    constructor(wrapper) {
        this.wrapper = wrapper;
        this.items = [...this.wrapper.querySelectorAll('.j-parallax__item')];
        this.items.forEach((item) => {
            item.speedX = Number(item.getAttribute('data-speed-x'));
            item.speedY = Number(item.getAttribute('data-speed-y'));
            item.speed = Number(item.getAttribute('data-speed')) || 1;
            // item.ox = Boolean(item.getAttribute('data-ox'));
        });
        this.wrapperWidth = this.wrapper.getBoundingClientRect().width;
        this.wrapperHeight = this.wrapper.getBoundingClientRect().height;
        this.isDesktop = !Utils.isMobile();

        this._bindEvents();
    }

    _bindEvents() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, this._setSize.bind(this));
        });

        this.wrapper.addEventListener('mousemove', this._setItemsTranslate.bind(this));

        this.wrapper.addEventListener('mouseleave', this._removeItemsTranslate.bind(this));
    }

    _setSize() {
        this.isDesktop = !Utils.isMobile();

        if (!this.isDesktop) {
            this._removeItemsTranslate();
        }
    }

    _setItemsTranslate(event) {
        if (!this.isDesktop) {
            return;
        }


        this.items.forEach((item) => {
            let translateX = '';
            let translateY = '';

            const moveX = (speedX) => {
                const offsetX = event.pageX - (this.wrapperWidth * 0.5);
                const x = (offsetX * speedX) / 100;

                return `translateX(${x}px)`;
            };

            const moveY = (speedY) => {
                const offsetY = event.pageY - (this.wrapperHeight * 0.5);
                const y = (offsetY * speedY) / 100;

                return `translateY(${y}px)`;
            };

            // если надо только по ОX двигать
            if (item.speedX) {
                translateX = moveX(item.speedX);

            // если надо только по ОY двигать
            } else if (item.speedY) {
                translateY = moveY(item.speedY);

            // если надо по всем осям
            } else {
                translateX = moveX(item.speed);
                translateY = ` ${moveY(item.speed)}`;
            }

            item.style.transform = `${translateX}${translateY}`;
        });
    }

    _removeItemsTranslate() {
        this.items.forEach((item) => {
            item.style.transform = '';
        });
    }
}

export default ParallaxMouse;
